// extracted by mini-css-extract-plugin
export default {"wrapper":"kPGUiISt3gGZhNGr4Umn","open":"wwkaT7mCvr7tJlJU30Xw"};